export class Contact {
  constructor(
    public id: string,
    public name: string,
    public email: string,
    public message: string,
    public ip: number
  ) {}
}

